export class MissingTokenError extends Error {}
export class FronteggSignupError extends Error {}
export class FronteggSigninError extends Error {}

export type RecaptchaErrorType =
  /** When recaptcha scripts have not finished loading */
  | 'RECAPTCHA_HASNT_LOADED'
  /** When recaptcha scripts fail loading due to things like network blocking */
  | 'RECAPTCHA_FAILED_LOADING'
  /** When recaptcha scripts fail executing. The scripts loaded but something prevented them from executing succesfully  */
  | 'RECAPTCHA_FAILED_EXECUTING'
  /** When a user failed validation with recaptcha. E.g. They did not meet the minimun score threshold */
  | 'RECAPTCHA_FAILED_VALIDATION'

export class RecaptchaError extends Error {
  message: RecaptchaErrorType

  constructor(message: RecaptchaErrorType, options?: ErrorOptions) {
    super(message, options)
    this.message = message
  }
}
